import * as React from 'react';
import CheckFill from '../icons/checkFilled';
import CheckOut from '../icons/checkOutline';
import ErrorFill from '../icons/errorFilled';
import ErrorOut from '../icons/errorOutline';
import InfoOut from '../icons/infoWarningOutline';
import InfoFill from '../icons/infoWarningFilled';
var CheckFilled = function () {
    return (React.createElement("span", { className: "ant-icon", role: "img", "aria-label": "check-filled" },
        React.createElement(CheckFill, null)));
};
var CheckOutline = function () {
    return (React.createElement("span", { className: "ant-icon", role: "img", "aria-label": "check-outline" },
        React.createElement(CheckOut, null)));
};
var ErrorFilled = function () {
    return (React.createElement("span", { className: "ant-icon", role: "img", "aria-label": "error-filled" },
        React.createElement(ErrorFill, null)));
};
var ErrorOutline = function () {
    return (React.createElement("span", { className: "ant-icon", role: "img", "aria-label": "error-outline" },
        React.createElement(ErrorOut, null)));
};
var InfoFilled = function () {
    return (React.createElement("span", { className: "ant-icon", role: "img", "aria-label": "info-filled" },
        React.createElement(InfoFill, null)));
};
var InfoOutline = function () {
    return (React.createElement("span", { className: "ant-icon", role: "img", "aria-label": "info-outline" },
        React.createElement(InfoOut, null)));
};
var WarningFilled = function () {
    return (React.createElement("span", { className: "ant-icon", role: "img", "aria-label": "warning-filled" },
        React.createElement(InfoFill, null)));
};
var WarningOutline = function () {
    return (React.createElement("span", { className: "ant-icon", role: "img", "aria-label": "warning-outline" },
        React.createElement(InfoOut, null)));
};
export { CheckFilled, CheckOutline, ErrorFilled, ErrorOutline, InfoFilled, InfoOutline, WarningFilled, WarningOutline };
